import React, { FC } from 'react';
import { find } from 'lodash';
import { matchPath } from 'react-router-dom';
import { Wrapper } from '@src/components/Wrapper';
import TabNavigations from '@src/components/TabNavigations';
import { createLink } from '@src/util/createLink';
import { COMPANY_PUBLIC_PROFILE_ROUTE, COMPANY_REVIEWS_ROUTE } from '@src/Routes/links';
import { GetTabsValueItem } from './interfaces/getTabs.interface';
import { HeaderProps } from './props';
import './styles.scss';

export const Header: FC<HeaderProps> = ({ location, companyProfileId }) => {
  const isReviewsRoute =
    location && find([COMPANY_REVIEWS_ROUTE], route => matchPath(location.pathname, { path: route }));

  const getTabs = (companyProfileId: string): GetTabsValueItem[] => {
    return [
      {
        label: 'Public profile',
        name: 'profile',
        to: createLink({
          link: COMPANY_PUBLIC_PROFILE_ROUTE,
          params: { companyProfileId },
        }),
      },
      {
        label: 'Reviews',
        name: 'reviews',
        to: createLink({
          link: COMPANY_REVIEWS_ROUTE,
          params: { companyProfileId },
        }),
      },
    ];
  };

  return (
    <div className="company-agent-header">
      <div className="company-agent-header__wrapper">
        <Wrapper>
          <>
            <div className="company-agent-header__title">
              <h2>Company</h2>
            </div>

            {companyProfileId && (
              <TabNavigations activeTab={isReviewsRoute ? 'reviews' : 'profile'} tabs={getTabs(companyProfileId)} />
            )}
          </>
        </Wrapper>
      </div>
    </div>
  );
};
